import Vue from 'vue';

import {load} from 'recaptcha-v3';

Vue.prototype.$recaptcha = async () => load(
	process.env.GOOGLE_RECAPTCHA_KEY, {
		autoHideBadge: true
	});
